/**
 * The app's one keyboard focus indicator: the "Modern focus styles" outline
 * from index.css (2px solid primary, offset 2px) expressed as utilities so it
 * wins over any `outline-none` in the same class list. Outline is used rather
 * than the Tailwind box-shadow ring because the global button transition on
 * box-shadow leaves that ring stuck at zero width on first focus in Chrome.
 *
 * The outline only paints for keyboard use: lib/focus-modality.ts stamps
 * data-input-modality on <html> and index.css hides the outline while the
 * last interaction was a pointer, which stops Radix's script-returned focus
 * lighting up a trigger after a mouse close.
 *
 * Sidebar controls keep their own `ring-sidebar-ring` recipe: a primary
 * coloured outline on a primary coloured sidebar would be invisible.
 */
export const FOCUS_RING =
  'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary'

/** Same outline with no offset, for chips and controls inside table cells. */
export const FOCUS_RING_INSET =
  'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-0 focus-visible:outline-primary'

/**
 * Drawn inside the control, for segments of a group that clips its children
 * (the overflow-hidden copy / open pill in record headers), where an outline
 * outside the box would be cut off.
 */
export const FOCUS_RING_INNER =
  'focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-primary'
